<template>
  <div class="content">
    <el-upload
      ref="fileUpload"
      :http-request="manualUpload"
      :before-upload="beforeUpload"
      :before-remove="beforeRemove"
      :on-remove="handleRemove"
      :on-success="handleSuccess"
      :on-exceed="handleExceed"
      :drag="listType !== 'picture-card'"
      :accept="accept"
      :multiple="limit > 1"
      :limit="limit === 1 ? 2 : limit"
      :file-list="fileList"
      :list-type="listType"
      :data="dataObj"
      action=""
      :on-preview="handlePictureCardPreview"
    >
      <i v-if="listType === 'picture-card'" class="el-icon-plus" />

      <i v-if="listType !== 'picture-card'" class="el-icon-upload" />
      <div v-if="listType !== 'picture-card'" class="el-upload__text">
        将文件拖到此处，或
        <em>点击上传</em>
      </div>
      <div v-if="tips" slot="tip" class="el-upload__tip">{{ tips }}</div>

    </el-upload>

    <!-- <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog> -->

    <FileView ref="FileViewRef" :dlgData0="previewData" />
  </div>
</template>

<script>
import * as utils from "@/utils/index";
import { buildDir } from "@/utils/examMan/file-utils";
import { fetchToken } from "@/api/examMan/sys/config/qiniu";
import { fetchDetail } from "@/api/examMan/sys/config/prop";
import { compressImage } from "@/utils/examMan/upload";
import { post } from "@/utils/examMan/request";
import FileView from "@/views/examMan/admin/course/file/fileView";
export default {
  name: "FileUploadQiniu",
  components: { FileView },
  props: {
    value: {
      type: Array,
      default() {
        return [];
      }
    },
    accept: String,
    tips: String,
    listType: String,
    limit: {
      type: Number,
      default: 1
    },
    compress: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      fileStype: "image",

      fileList: [],
      dataObj: {
        token: ""
      },
      fileNames: [],
      conf: {
        endpoint: ""
      },

      // 放大
      dialogVisible: false,
      dialogImageUrl: "",

      previewData: {}
    };
  },
  watch: {
    // 检测查询变化
    value: {
      handler() {
        this.fillValue();
      }
    },
    accept: {
      handler(val) {
        if (val.indexOf(".jpg") >= 0) {
          this.fileStype = "image";
        } else {
          this.fileStype = "noImage";
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.fetchConfig();
  },

  created() {
    this.fillValue();
  },
  methods: {
    //  handleRemove(file) {
    //     console.log(file);
    //   },
    handlePictureCardPreview(file) {
      let fileTypeArr = file.url.split(".");
      let fileTypeStr = fileTypeArr[fileTypeArr.length - 1];

      let timestr = new Date()

      this.previewData = {
        id: timestr.getTime(),
        viewUrl: file.url,
        fileUrl: file.url
      };

      let officeStr = ".doc, .docx, .xls, .xlsx, .ppt, .pptx";
      let pdfStr = ".pdf";
      let mp4Str = ".mp4, .mov, .flv, .mkv, .rm, .rmvb, .webm, .ogv, .avi";
      let imgStr = '.jpg,.jpeg,.png'
      if (officeStr.indexOf(fileTypeStr) >= 0) {
        this.previewData.fileType = "11";
        this.previewData.viewUrl += '?doc-convert/preview'
      }
      if (pdfStr.indexOf(fileTypeStr) >= 0) {
        this.previewData.fileType = "22";
      }
      if (mp4Str.indexOf(fileTypeStr) >= 0) {
        this.previewData.fileType = "33";
      }
      if (imgStr.indexOf(fileTypeStr) >= 0) {
        this.previewData.fileType = "44";
      }

      console.log('上传后预览', this.previewData)
      this.$refs.FileViewRef.dlgState = true

      // if (this.fileStype == "image") {
      //   this.dialogImageUrl = file.url;
      //   this.dialogVisible = true;
      // } else {
      //   window.open(file.url);
      // }
    },
    // handleDownload(file) {
    //   console.log(file);
    // },
    // 填充数据
    fillValue() {
      this.fileList = this.value;
    },

    // 获取基础配置
    fetchConfig() {
      fetchDetail("upload", "").then(res => {
        // 配置信息
        this.conf = res.data.data;

        console.log("获得配置1", this.conf);

        // 获得上传Token
        fetchToken()
          .then(res1 => {
            this.dataObj.token = res1.data.data.token;
            console.log("获得配置2", res1.data.data);
          })
          .catch(err => {
            this.$message.error(`获取上传令牌失败： ${err} `);
          });
      });
    },

    // 文件超出个数限制时的钩子
    handleExceed() {
      this.$message.warning(`每次只能上传 ${this.limit} 个文件`);
    },
    // 删除文件之前的钩子
    beforeRemove() {
      return this.$confirm(`确定移除文件吗？`);
    },
    // 文件列表移除文件时的钩子
    handleRemove(file) {
      // 移除文件
      for (let i = 0; i < this.fileList.length; i++) {
        if (file.uid === this.fileList[i].uid) {
          this.fileList.splice(i, 1);
        }
      }
    },
    // 文件上传成功时的钩子
    handleSuccess(response, file, fileList) {
      // 只能传一个的进行替换
      if (this.limit === 1 && fileList.length > 1) {
        const url = this.conf.data.url + this.fileNames[file.uid];
        // 反转并保留一个
        fileList = [{ url: url, name: url }];
      } else {
        // 上传成功替换服务端URL
        for (let i = 0; i < fileList.length; i++) {
          if (file.uid === fileList[i].uid) {
            fileList[i].url = this.conf.data.url + this.fileNames[file.uid];
          }
        }
      }
      this.$emit("input", fileList);
    },

    // 文件上传前的校验
    beforeUpload(file) {
      this.$emit("select", file.name);
      return compressImage(file, this.compress);
    },

    // 手动上传文件
    manualUpload(param) {
      const file = param.file;
      const key = this.buildName(file);
      this.fileNames[file.uid] = key;
      const form = new FormData();
      form.append("token", this.dataObj.token);
      form.append("key", key);
      form.append("file", file);
      // 监听进度
      const options = {
        onUploadProgress: function(progressEvent) {
          const percent = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          param.onProgress({ percent: percent });
        }
      };
      console.log("===上传文件", file.size);
      window.sessionStorage.examFileSize = parseInt(file.size / 1024);
      console.log('上传文件1')
      // 上传文件
      post(this.conf.data.endpoint, form, options).then(() => {
        param.onSuccess();
      });
    },
    // 重命名文件
    buildName(file) {
      const temporary = file.name.lastIndexOf(".");
      const fileNameLength = file.name.length;
      const fileFormat = file.name.substring(temporary + 1, fileNameLength);
      return buildDir() + "." + fileFormat;
    }
  }
};
</script>
